import { useEffect } from 'react';
import { generatePath } from 'react-router';

import { Navigate } from '@sorare/routing';

import { So5FixtureEvent } from '@sorare/core/src/__generated__/globalTypes';
import {
  ANY_SPORT_ONBOARDING_SERIES_SELECT_COMPETITION,
  FOOTBALL_ONBOARDING_CHOOSE_YOUR_LEVEL,
} from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';

import { useFootballEvents } from '@sorare/marketplace/src/shared/events/lib';

const ProOnboardingPage = () => {
  const track = useFootballEvents();
  const {
    flags: { enableSeriesOnboardingPacks = false },
  } = useFeatureFlags();
  const { generateSportContextPath } = useSportContext();

  useEffect(() => {
    track('Enter General Tutorial');
  }, [track]);

  if (enableSeriesOnboardingPacks) {
    return (
      <Navigate
        to={generateSportContextPath(
          ANY_SPORT_ONBOARDING_SERIES_SELECT_COMPETITION
        )}
        replace
      />
    );
  }

  return (
    <Navigate
      to={generatePath(FOOTBALL_ONBOARDING_CHOOSE_YOUR_LEVEL, {
        eventType: So5FixtureEvent.CLASSIC.toLowerCase(),
      })}
      replace
      keepSearchParams
    />
  );
};

export default ProOnboardingPage;
